export default (theme) => ({
    root: {
        display: 'flex',
        alignItems: 'flex-start',
    },
    label: {
        width: 153,
        flexShrink: 0,
        padding: '15px 0 5px 0',
        marginRight: 13,
    },
    linearVertical: {
        flexDirection: 'column',
        flex: 1,
    },
    linearHorizontal: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        gap: 8,
    },
});
